<div *ngIf="airport.localAttractions.length >= 1; else placeholder" class="local-attractions">
  <div #listEl class="local-attractions__list">
    <div #attractionEl class="local-attractions__attraction" *ngIf="editModeSet" >
      <button id="add_attr_btn" (click)="openEditAttractionDialog(null)" mat-mini-fab>
        <mat-icon aria-label="Add Attraction">add</mat-icon>
      </button>
      Add attraction
    </div>
    <div #attractionEl class="local-attractions__attraction" *ngFor="let attraction of airport.localAttractions; let i = index"
         [class.local-attractions__attraction--active]="attraction === selectedAttraction"
         (mouseover)="onAttractionItemHover(attraction, true)"
         (mouseout)="onAttractionItemHover(attraction, false)">
      <div class="local-attractions__attraction-header">
        <mat-icon (click)="openEditAttractionDialog(i)" *ngIf="editModeSet" class="edit-icon" mat-tooltip="Edit" aria-label="Edit attraction">edit</mat-icon>
        <mat-icon (click)="deleteAttraction(i)" *ngIf="editModeSet" class="delete-icon" mat-tooltip="Delete" aria-label="Delete attraction">delete_outline</mat-icon>
        <a *ngIf="attraction.website; else attractionHeader" [href]="getWebsite(attraction)"
           class="local-attractions__attraction-link" target="_blank">
          <ng-container [ngTemplateOutlet]="attractionHeader"></ng-container>
          <mat-icon class="local-attractions__external-link" fontSet="fa" fontIcon="fa-external-link"></mat-icon>
        </a>
        <ng-template #attractionHeader>
          <h4 class="local-attractions__header-text">{{ attraction.name }}</h4>
        </ng-template>
      </div>
      <div class="local-attractions__attraction-body">
        <div *ngIf="getAddress(attraction).length > 1" class="local-attractions__field">
          <mat-icon class="local-attractions__field-icon">location_on</mat-icon>
          <div class="local-attractions__field-value">{{ getAddress(attraction) }}</div>
        </div>
        <div *ngIf="attraction.phone" class="local-attractions__field">
          <mat-icon class="local-attractions__field-icon">phone</mat-icon>
          <div class="local-attractions__field-value">{{ attraction.phone | phone }}</div>
        </div>
      </div>
    </div>
  </div>
  <agm-map class="local-attractions__map" [latitude]="airport.location.lat" [longitude]="airport.location.lon"
           [zoomControl]="true" [disableDefaultUI]="true" [streetViewControl]="false" [mapDraggable]="true"
           [fitBounds]="attractions.length === 0 ? false : true" [scrollwheel]="true" [zoom]="14">
    <agm-marker #airportMarker
                [latitude]="airport.location.lat" [longitude]="airport.location.lon"
                [iconUrl]="'assets/icons/airport.png'"
                [openInfoWindow]="false"
                [agmFitBounds]="true"
                (markerClick)="onAirportMarkerClick()"
                (mouseOver)="onAirportMarkerHover(true)"
                (mouseOut)="onAirportMarkerHover(false)">
      <agm-info-window #airportInfoWindow>
        <div class="agm-info-window-content">
          {{airport.faaId}}
        </div>
      </agm-info-window>
    </agm-marker>
    <agm-marker #attractionMarker
                *ngFor="let attraction of attractions"
                [latitude]="attraction.location.lat"
                [longitude]="attraction.location.lon"
                [iconUrl]="'assets/icons/' + getIconType(attraction) +'.png'"
                [openInfoWindow]="false"
                [agmFitBounds]="true"
                (markerClick)="onAttractionMarkerClick(attraction)"
                (mouseOver)="onAttractionMarkerHover(attraction, true)"
                (mouseOut)="onAttractionMarkerHover(attraction, false)">
      <agm-info-window #attractionInfoWindow>
        <div class="agm-info-window-content">
          {{attraction.name}}
        </div>
      </agm-info-window>
    </agm-marker>
  </agm-map>
</div>
<ng-template #placeholder>
  <div *ngIf="editModeSet; else placeholderNoEdit" class="local-attractions">
    <div #listEl class="local-attractions__placeholder">
      <div #attractionEl class="local-attractions__attraction" *ngIf="editModeSet" >
        <button id="add_attr_btn" (click)="openEditAttractionDialog(null)" mat-mini-fab>
          <mat-icon aria-label="Add Attraction">add</mat-icon>
        </button>
        Add attraction
      </div>
      <div class="detail-page__placeholder">
        <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
        <div class="detail-page__placeholder-message">
          There are no attractions currently list for this airport.  Please contact the AOPA Aiport Directory Administrator
          at <a href="mailto:airportdirectory@aopa.org?subject=Airport%20Local%20Attractions">airportdirectory@aopa.org</a>
          if you know of any that should be added.
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #placeholderNoEdit>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">
      There are no attractions currently list for this airport.  Please contact the AOPA Aiport Directory Administrator
      at <a href="mailto:airportdirectory@aopa.org?subject=Airport%20Local%20Attractions">airportdirectory@aopa.org</a>
      if you know of any that should be added.
    </div>
  </div>
</ng-template>
